var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.defineWhere()}},[_c('section',{staticClass:"projectWrapper"},[_c('i',{staticClass:"fas fa-image text-light"}),_c('br'),_c('h1',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.project))])])])}
var staticRenderFns = []

export { render, staticRenderFns }